'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('SalesManager', ['Role', function(Role) {
    return Role.newFrozenInstance(
        'ListClusters',
        'ListOrders',
        'ViewOrder',
        'UpdateOrder',
        'CancelOrder',
        'CopyOrder',
        'ShowOrderAuditHistory',
        'ShowOrderBuySheet',
        'CreateOrderNotification',
        'CreateOrderComment',
        'ListOrderComments',
        'DeleteOrderComment',
        'ListOrderTasks',
        'ShowOrderTask',
        'CreateOrderTask',
        'ListOrderLineItems',
        'CreateOrderLineItem',
        'ViewLineItem',
        'UpdateLineItem',
        'CancelLineItem',
        'CopyLineItem',
        'ViewFlight',
        'UpdateFlight',
        'CancelFlight',
        'CopyFlight',
        'ShowLineItemAuditHistory',
        'ShowLineItemDownloadPdf',
        'UpdateLineItemCampaignManager',
        'CreateLineItemComment',
        'ListLineItemComments',
        'DeleteLineItemComment',
        'ListLineItemTasks',
        'ShowLineItemTask',
        'CreateLineItemTask'
    )
}]);